import {ActionReducer, MetaReducer} from '@ngrx/store';
import {LocalStorageActionService} from './local-storage-action.service';
import {AppState} from './state/AppState';

export function getMetaReducersFactory(storageService: LocalStorageActionService): MetaReducer<AppState> {
  return (reducer: ActionReducer<any>) => (state, action) => {

    if (!isInitAction()) {
      if (isLoadAction()) {
        console.log('Loading stored state')
        state = storageService.actions.reduce((accState, nextAction) => reducer(accState, nextAction), {});
      } else {
        storageService.saveAction(action);
      }
    }
    return reducer(state, action);

    function isLoadAction() {
      return action.type === '[Action] Load actions';
    }

    function isInitAction() {
      return action.type === '@ngrx/store/init' || action.type === '@ngrx/effects/init';
    }
  };
}
